import { portfolioButtonStyles } from '../../../styles';

export default theme => ({
  ...portfolioButtonStyles(theme),
  noTitlePadding: {
    paddingTop: theme.spacing(3),
  },
  dialogContainer: {
    maxWidth: '100%',
    boxShadow: `0 2px 10px 1px ${theme.palette.background.grid} !important`,
    // padding: theme.spacing(2),
  },
  dialogActions: {
    backgroundColor: theme.palette.background.main,
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
  },
  headerTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
  },
  dialogContent: {
    backgroundColor: theme.palette.background.main,

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  dialogContentText: {
    color: `${theme.palette.text.primary} !important`,
    padding: `${theme.spacing(2)} !important`,
  },
  submitButton: {
    borderRadius: '4px !important',
    backgroundColor: '#31006F !important',
    color: '#FFFFFF !important',
    padding: `${theme.spacing(1)} ${theme.spacing(3)} !important`,
    minWidth: '140px !important',
    width: 'fit-content !important',
    fontSize: '16px !important',
    fontWeight: '600 !important',
    textTransform: 'none !important',
    '&:hover': {
      backgroundColor: '#31006F !important',
    },
  },
});
